<template>
    <div class="body">
        <div v-for="(item,index) in infos" :key="index">
            <div class="content" @click="toDetail(item)">
                <div class="cover"><img :src="item.coverImg" style="width: 100%;height: 100%;"></div>
                <div style="margin-left: 0.2rem;">
                    <div class="title">{{item.title}}</div>
                    <div class="time">{{item.time}}</div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "message",
        data() {
            return {
                infos:[],
            }
        }, created() {
            this.util.title("消息通知");
            this.getData();
        }, methods: {
            getData() {
                this.$get("/app/v1/tcHelp/messages").then((res) => {
                    if (res.code == 200) {
                        this.infos = res.data;
                        console.log(this.infos)
                    } else {
                        this.util.toast({msg: res.msg, type: "fail"});
                    }
                });
            },toDetail(item){
                window.location.href=item.redirectUrl;
            }
        }
    }
</script>

<style scoped>
    * {
        font-family: PingFangSC-Medium, PingFang SC;
    }
    .body{
        background: #F7F7F7;
        padding-top: 0.2rem;

    }

    .content{
        width: 90%;
        background: #fff;
        border-radius: 4px;
        margin: 0rem auto;
        margin-bottom: 0.15rem;
        display: flex;
        padding: 0.25rem 0.16rem;
    }
    .content .cover{
        width: 0.8rem;
        height: 0.56rem;
    }

    .content .title{
        font-size: 0.14rem;
        font-weight: 500;
        color: #333333;
    }

    .content .time{
        font-size:0.12rem;
        font-weight: 400;
        color: #999999;
        margin-top: 0.2rem;
    }

</style>
